import React from "react";

import { createClassNameString } from "@/utils/createClassNameString";

import "../styles.scss";

export const FormFieldContainer = ({ children, className, subTitle, title }) => {
  return (
    <div className={createClassNameString(["FormField-container", className])}>
      {(title || subTitle) && (
        <div className="FormField-header_container" data-public>
          {title && <h3 className="FormField-title">{title}</h3>}
          {subTitle && <h3 className="FormField-subTitle">{subTitle}</h3>}
        </div>
      )}
      {children}
    </div>
  );
};
